import "./ImpactStories.module.css";
import MainNavigation from "@/reusable_sections/Header";
import InstitutionalSuccess from "./sections/InstitutionalSuccess";
import VoicesOfLeadership from "./sections/VoicesOfLeadership";
import Footer from "@/reusable_sections/Footer";
export default function ImpactStoriesPage() {
  return <div>
      <MainNavigation />
      <InstitutionalSuccess />
      <VoicesOfLeadership />
      <Footer />
    </div>;
}